import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import BackButton from '../../common/BackButton';
import ListOfFundsFilters from '../../libraryOfFunds/ListOfFundsFilters';
import ListOfFunds from '../../libraryOfFunds/ListOfFunds';
import ListOfFundsPagination from '../../libraryOfFunds/ListOfFundsPagination';
import FundSelectionConstruction from './FundSelectionConstruction';
import { useNavigate, useParams } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants';
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store';
import { saveDraft, updatePortfolio } from '../../../store/actions/createPortfolio';
import useIsFullable from '../../../hooks/useIsFullable';

export interface IFundSelectionStepProps { }

const FundSelectionStep: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const isFullable = useIsFullable();


    const onConfigure = () => {
        dispatch(updatePortfolio({ field: 'step', value: 3 }));
        dispatch(saveDraft()).then(() => {
            navigate((id !== undefined ? AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_STEP_ROUTE.replace(":id", id) : AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_STEP_ROUTE).replace(":step", '3'));
        });
    }

    const onSaveDraft = () => {
        dispatch(saveDraft()).then(() => {
            navigate(AUTHENTICATED_ROUTES.PORTFOLIOS_CONFIRM_SAVE_ROUTE.replace(":confirmSave", "saved"));
        })
    }

    return <Box display={"flex"} flexDirection={"column"} width={"1400px"} gap={"24px"} paddingBottom={"50px"}>
        <Box display={"flex"} alignItems={"center"} gap={"24px"}>
            <BackButton />
            <Typography fontSize={"24px"} fontWeight={"500"} lineHeight={"29.26px"}>Select Funds</Typography>
        </Box>
        <Box display={"flex"} width={"100%"}>
            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} flexGrow={1} flexBasis={"45%"}>
                <ListOfFundsFilters smallDesign />
                <ListOfFunds createPortfolio />
            </Box>
            <Box display={"flex"} flexDirection={"column"} flexGrow={1} flexBasis={"45%"}>
                <FundSelectionConstruction />
            </Box>
        </Box>
        <Box display={"flex"} width={"100%"} justifyContent={"flex-end"} gap={"16px"}>
            <Button variant='contained' onClick={onConfigure} disabled={!isFullable}>Confirm & Configure</Button>
            <Button variant='outlined' onClick={onSaveDraft}>Save as draft</Button>
        </Box>
    </Box>
}

export default FundSelectionStep